module.exports = __webpack_public_path__ + "img/icons B_35.61435bb1.png";